/**
 * Detektor ceskeho textu psaneho jako identifikator (krok C2b bod 3).
 *
 * Cestina je zdrojovy jazyk (CLAUDE.md §5) a zakaznik vidi presne to, co je
 * v katalogu nebo v datovem souboru. Tvary jako „Riziko povodne" nebo
 * „Rucni proverenie" nejsou preklep - je to text, ktery nekdo psal bez
 * diakritiky, protoze byl zvykly psat identifikatory. Identifikatory (klice,
 * kody, enumy, URL) ASCII zustavaji; tenhle detektor patri na HODNOTY
 * urcene cloveku.
 *
 * Seznam je zamerne uzky a konkretni: hlida tvary, ktere v repu skutecne
 * vznikly (audit kroku C2), ne "kazde slovo bez hacku" - spousta ceskych
 * slov diakritiku nema (inspekce, nemovitost, adresa, doklad).
 */
export const MISSING_DIACRITICS_RULES = [
    { pattern: /\bpovodne\b/i, correct: 'povodně' },
    { pattern: /\bpovodni\b/i, correct: 'povodní' },
    { pattern: /\brucni\b/i, correct: 'ruční' },
    { pattern: /\bproverenie?\b/i, correct: 'prověření' },
    { pattern: /\bzakladni\b/i, correct: 'základní' },
    { pattern: /\brozsirene\b/i, correct: 'rozšířené' },
    { pattern: /\bpracovni\b/i, correct: 'pracovní' },
    { pattern: /\btechnicka\b/i, correct: 'technická' },
    { pattern: /\btechnicky\b/i, correct: 'technický' },
    { pattern: /\bzprava\b/i, correct: 'zpráva' },
    { pattern: /\bcislo\b/i, correct: 'číslo' },
    { pattern: /\buzemi\b/i, correct: 'území' },
];
/**
 * Popis prvniho nalezeneho tvaru bez diakritiky, nebo `null`, kdyz je text
 * v poradku. Vraci se popis (ne jen boolean), aby chyba testu rovnou rekla,
 * co se ma opravit.
 */
export function missingDiacritics(text) {
    for (const rule of MISSING_DIACRITICS_RULES) {
        const match = rule.pattern.exec(text);
        if (match !== null)
            return `„${match[0]}" -> „${rule.correct}"`;
    }
    return null;
}
//# sourceMappingURL=diacritics.js.map